import { useState, useEffect, ReactNode } from 'react';
import { sessionRefresher } from '@/api/api-client';

import {
  AuthContext,
  type AuthContextUser,
} from './auth-context.shared';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<AuthContextUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Charger l'utilisateur depuis localStorage au démarrage
  useEffect(() => {
    const storedUser = localStorage.getItem('yodi-user');
    const token = localStorage.getItem('yodi-token') ?? localStorage.getItem('token');

    if (!localStorage.getItem('yodi-token') && token) {
      localStorage.setItem('yodi-token', token);
      localStorage.removeItem('token');
    }
    
    if (storedUser && token) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('yodi-user');
        localStorage.removeItem('yodi-token');
        localStorage.removeItem('token');
      }
    }
    
    setIsLoading(false);
  }, []);

  const logout = () => {
    sessionRefresher.end();
    setUser(null);
    localStorage.removeItem('yodi-token');
    localStorage.removeItem('token');
    localStorage.removeItem('yodi-user');
  };

  const handleSetUser = (newUser: AuthContextUser | null) => {
    setUser(newUser);
    if (newUser) {
      localStorage.setItem('yodi-user', JSON.stringify(newUser));
    }
  };

  if (isLoading) {
    return null; // ou un spinner
  }

  return (
    <AuthContext.Provider value={{ 
      user, 
      setUser: handleSetUser, 
      logout,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};
